import React from 'react';
import ReactModal from 'react-modal';
import { PropsFromRedux } from '.';
import { Datum } from '../../interfaces';
import ConfirmationModal from '../ConfirmationModal';
import ItemModal from '../DropoffForm/ItemModal';
import FundWallet from '../FundWallet';
import Confirmation from '../OverseasShippingForm/Modals/Confirmation';
import SenderIdForm from '../OverseasShippingForm/Modals/Identification';
import ShipmentMessage from '../OverseasShippingForm/Modals/ShipmentMessage';
import PriceQuoteModal from '../PriceQuoteModal';
import RateModal from '../RateModal';
import ServiceCenterModal from '../ServiceCenterModal';
import TonnageModal from '../TonnageModal';
import TrackRider from '../TrackRider';
import TrackShipment from '../TrackShipment';
import ConfirmTransactionPin from '../ConfirmTransactionPIn';
import BillSuccessful from '../BillSuccessful';
import WalletPinModal from '../WalletPinModal';
import WalletPinSetup from '../WalletPinSetup';
import ConfirmWalletPin from '../ConfirmWalletPin';
import WalletPinOtp from '../WalletPinOtp';
import PinSuccessfulModal from '../PinSuccessfulModal';
import ChangeWalletPin from '../ChangeWalletPin';
import ResetWalletPin from '../ResetWalletPin';
import ResetPinOtp from '../RestPinOtp';
import PaymentValidationTimer from '../PaymentValidationTimer';
import BillFailed from '../BillFailed';
import CustomerValidationError from '../CustomerValidationError';
import DeliveryType from '../DeliveryType';
import CouponModal from '../CouponModal';
import AddItem from '../OutboundShipmentForm/FormData/AddItem';
import EditItem from '../OutboundShipmentForm/FormData/EditItem';
import EditNonDocumentItem from '../OutboundShipmentForm/FormData/EditNonDocumentItem';
import AddNonDocumentItem from '../OutboundShipmentForm/FormData/AddNonDocumentItem';
import TrackAlpha from '../TrackAlpha';
import DeliveryMethod from '../AlphaProductDetails/ProductModal/DeliveryMethod';
import UserDetails from '../AlphaProductDetails/ProductModal/UserDetails';
import PickupStation from '../AlphaProductDetails/ProductModal/PickupStation';
import PaymentMethod from '../AlphaProductDetails/ProductModal/PaymentMethod';
import OrderSuccessful from '../OrderSuccessful/OrderSuccessful';
import Withdraw from '../Withdraw';
import ConfirmTransactionPinCod from '../ConfirmTransactionPinCod';
import WithdrawSuccess from '../WithdrawSuceesss';
import CodAccountSuccess from '../CodAccountSuccess';
import StellasAccountDetails from '../StellasAccountDetails';
import CodAccountStatement from '../CodAccountStatement';
import CodAmountModal from '../CodAmountModal';
import ReceiverDetails from '../PersonalShoppingForm/Modals/ReceiverDetails';
import ReceiverList from '../PersonalShoppingForm/Modals/ReceiverList';
import OrderSuccess from '../PersonalShoppingForm/Modals/OrderSuccess';
import PaymentSuccess from '../PersonalShoppingForm/Modals/PaymentSuccess';
import DeleteShoppingItem from '../PersonalShoppingForm/Modals/DeleteItem/DeleteShoppingItem';
import PaymentSuccessfulShopper from '../PaymentSuccessfulShopper';
import AddShopperItem from '../PersonalShoppingForm/Modals/AddShopperItem';
import UpdateShopperItem from '../PersonalShoppingForm/Modals/UpdateShopperItem';
import PaymentFailedShopper from '../PersonalShoppingForm/Modals/PaymentFailedShopper';
import DeleteShopperItem from '../PersonalShoppingForm/Modals/DeleteShopperItem';
// added
import EditDropoffModal from '../EditDropoffModal/EditDropoffModal';

// added
import AlphaPaymentSuccessful from '../AlphaPaymentSuccessful';

interface Props extends PropsFromRedux {}

export const ModalComponents: Datum = {
  SenderIdForm,
  Confirmation,
  TonnageModal,
  FundWallet,
  TrackShipment,
  TrackRider,
  ServiceCenterModal,
  ConfirmationModal,
  ShipmentMessage,
  RateModal,
  PriceQuoteModal,
  ItemModal,
  ConfirmTransactionPin,
  BillSuccessful,
  WalletPinModal,
  WalletPinSetup,
  ConfirmWalletPin,
  WalletPinOtp,
  PinSuccessfulModal,
  ChangeWalletPin,
  ResetWalletPin,
  ResetPinOtp,
  PaymentValidationTimer,
  BillFailed,
  CustomerValidationError,
  DeliveryType,
  CouponModal,
  AddItem,
  EditItem,
  EditNonDocumentItem,
  AddNonDocumentItem,
  TrackAlpha,
  DeliveryMethod,
  UserDetails,
  PickupStation,
  PaymentMethod,
  OrderSuccessful,
  AlphaPaymentSuccessful,
  Withdraw,
  ConfirmTransactionPinCod,
  WithdrawSuccess,
  CodAccountSuccess,
  StellasAccountDetails,
  CodAccountStatement,
  CodAmountModal,
  ReceiverDetails,
  ReceiverList,
  OrderSuccess,
  PaymentSuccess,
  DeleteShoppingItem,
  PaymentSuccessfulShopper,
  AddShopperItem,
  UpdateShopperItem,
  PaymentFailedShopper,
  DeleteShopperItem,
  // added
  EditDropoffModal,
};

const Modal: React.FC<Props> = ({ modal, showModal, hideModal }) => {
  const Component = modal?.component ? ModalComponents[modal?.component] : null;

  return (
    <ReactModal
      bodyOpenClassName="overflow-hidden"
      ariaHideApp={false}
      style={{
        overlay: {
          position: 'fixed',
          zIndex: 999,
          display: 'flex',
          bottom: 0,
          left: 0,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0,0,0,0.6)',
          ...modal.modalProps.style?.overlay,
        },
        content: {
          maxWidth: '800px',
          position: 'relative',
          height: 'auto',
          width: 'auto',
          padding: 0,
          inset: 'auto',
          border: 'none',
          backgroundColor: 'transparent',
          maxHeight: '80%',
        },
      }}
      {...modal.modalProps}
    >
      {Component ? (
        <Component modal={modal} showModal={showModal} hideModal={hideModal} />
      ) : null}
    </ReactModal>
  );
};

export default Modal;
